import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=c58c8b42&scoped=true&"
import script from "./AvatarUpload.vue?vue&type=script&lang=js&"
export * from "./AvatarUpload.vue?vue&type=script&lang=js&"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=c58c8b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c8b42",
  null
  
)

export default component.exports